export const truncate = (str, desiredLength) =>
  str.length > desiredLength ? `${str.substring(0, desiredLength - 3)}...` : str;

export const calculateReadTime = (article) => {
  const wordsPerMinute = 200;
  const noOfWords = article.split(/\s/g).length;
  const minutes = noOfWords / wordsPerMinute;
  const readTime = Math.ceil(minutes);
  return readTime
}